import React from "react";
// import { useAdmin } from "../AdminLayout/AdminProvider";
import {
  MapPin,
  FolderOpen,
  UserRound,
  Users,
  Building,
  TrendingUp,
  BarChart3,
} from "lucide-react";


export const Dashboard = () => {

  return (
    <div
      style={{
        display: "flex",
        height: "100vh", // fill viewport
        overflow: "hidden", // prevent body scroll
      }}
    >
 

      {/* Main Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden", // prevent main content overflow
        }}
      >
        {/* Scrollable Dashboard Content */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: 24,
            backgroundColor: "#f9f9f9",
          }}
        >
          {/* Header */}
          <div style={{ marginBottom: 32 }}>
            <h1 style={{ fontSize: 30, fontWeight: "bold", marginBottom: 8 }}>
              Dashboard
            </h1>
            <p style={{ color: "#666" }}>
              Welcome to Geo Admin Portal
            </p>
          </div>

       
        </div>
      </div>
    </div>
  );
};
